module.exports = __webpack_public_path__ + "static/media/Btn-Chevron-Red-Right.4bd842ff.svg";